import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-install-plugins',
  templateUrl: './install-plugins.component.html',
  styleUrls: ['./install-plugins.component.css']
})
export class InstallPluginsComponent implements OnInit {
   code:string = "import { Firebase } from '@ionic-native/firebase';";
   code1:string = `import { Firebase } from '@ionic-native/firebase'; <br><br>
    constructor( <br> &nbsp; private firebase: Firebase <br> ){ <br> &nbsp; this.firebase.getToken() <br> }`
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Consejos/install-plugins/install-plugins.component.ts